/**
 * Configuración central de idiomas para el SEO multiidioma (Fase 2).
 *
 * IMPORTANTE: el segmento de URL usa los códigos internos de la app
 * (los mismos que los archivos assets/i18n/<code>.json y la API de traducción),
 * mientras que el atributo `hreflang`/`lang` usa el código ISO correcto.
 * Por eso existe LANG_TO_ISO: la URL puede ser /po/ pero el hreflang será "pl".
 */

// Códigos internos de la app (= nombre de archivo i18n y parámetro de traducción)
export const SUPPORTED_LANGS = ['en', 'es', 'de', 'it', 'fr', 'po', 'ro', 'ch'];

export const DEFAULT_LANG = 'en';

// Código interno -> código ISO válido para hreflang / <html lang>
export const LANG_TO_ISO: { [key: string]: string } = {
  en: 'en',
  es: 'es',
  de: 'de',
  it: 'it',
  fr: 'fr',
  po: 'pl', // polaco
  ro: 'ro',
  ch: 'cs'  // checo
};

/** Devuelve true si el código es un idioma soportado. */
export function isSupportedLang(code: string | undefined | null): boolean {
  return !!code && SUPPORTED_LANGS.indexOf(code) !== -1;
}

/** Detecta el idioma del navegador, con fallback al idioma por defecto. */
export function detectBrowserLang(): string {
  const nav = (typeof navigator !== 'undefined' && navigator.language) ? navigator.language : DEFAULT_LANG;
  const code = nav.split('-')[0];
  return isSupportedLang(code) ? code : DEFAULT_LANG;
}
